export enum AlertRuleActionType {
  SEND_SLACK_NOTIFICATION = 'SEND_SLACK_NOTIFICATION',
}
